module.exports = __webpack_public_path__ + "img/architectural-evolution-5.cc983cde.png";